// React Native's release core expects a console global while initializing its
// error reporter. Install it before loading the app entry, including on TV
// Hermes runtimes that omit console in low-memory production processes.
const consoleFallback = { log() {}, warn() {}, error() {} };
global.console = global.console || consoleFallback;
globalThis.console = globalThis.console || global.console;
require('./src/entry/');
